<template>
  <div class="share-content">
    <!-- リンク -->
    <ul class="share-box">
      <li>
        <edit-link
          :ids="ids"
          :attrs="attrs"
          :partsContainerType="partsContainerType"
        />
      </li>
      <li>
        <fieldset class="edit-share-text">
          <label class="label-title">シェアテキスト</label>
          <div class="common-input">
            <input
              type="text"
              v-model="inputText"
              @blur="updatePartsContainer()"
            />
          </div>
        </fieldset>
      </li>
    </ul>
    <!-- SNSアイコン -->
    <ul>
      <draggable v-model="sharePartItems" draggable=".sns-icon-content" :group="'snsIcon'" handle=".sns-handle">
        <sns-icon-content
          v-for="sharePartItem in sharePartItems"
          :key="sharePartItem.table_id"
          :sectionId="sectionId"
          :partsContainerId="partsContainerId"
          :partsContainerType="partsContainerType"
          :partId="sharePartItem.id"
          :attrs="sharePartItem.attrs"
          :partsLength="sharePartItems.length"
          :partExistsSns="partExistsSns"
        />
      </draggable>
    </ul>
    <!-- SNS追加 -->
    <div v-if="showAddSnsButton">
      <div class="flex">
        <select-box
          :type="'add'"
          :partExistsSns="partExistsSns"
          @updateValue="updateValue($event)"
        />
        <button
          type="button"
          @click="addSnsButton()"
          class="w-b-btn"
        >
          追加
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import FollowButtonBase from '@/components/Content/Palette/EditPartDesign/Editor/FollowButton/FollowButtonBase'
import EditLink from '@/components/Content/Palette/EditPartDesign/Layouts/EditLink'
import SnsIconContent from '@/components/Content/Palette/EditPartDesign/Layouts/ContentTab/SnsIconContent'
import SelectBox from '@/components/Content/Palette/EditPartDesign/Editor/Share/EditSharePartSnsSelectBox'

const MAX_SNS_PART = 3

export default {
  props: [
    'sectionId',
    'partsContainerId',
    'partId',
    'parts',
    'partsContainerType',
    'attrs',
    'shareText',
  ],
  mixins: [
    FollowButtonBase,
  ],
  components: {
    Draggable,
    EditLink,
    SnsIconContent,
    SelectBox,
  },
  computed: {
    partExistsSns () {
      if (!this.parts) return
      let snsNames = []
      this.parts.forEach(part => {
        snsNames.push(part.attrs['data-sns-name'])
      })
      return snsNames
    },
    ids () {
      return {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.parts[0].id,
      }
    },
    sharePartItems: {
      get () {
        return this.parts
      },
      set (value) {
        this.$store.commit('sortSnsIcon', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          parts: value,
        })
      },
    },
    showAddSnsButton () {
      return this.parts.length < MAX_SNS_PART
    },
    // watchで監視するため、代表で最初のパーツのリンクを取得
    firstPartAttrHref () {
      if (!this.parts) return null
      return this.parts[0].attrs['href']
    },
    // watchで監視するため、代表で最初のパーツのタイトルを取得
    firstPartAttrTitle () {
      if (!this.parts) return null
      return this.parts[0].attrs['title']
    },
    // watchで監視するため、代表で最初のパーツのリンクターゲットを取得
    firstPartAttrTarget () {
      if (!this.parts) return
      return this.parts[0].attrs['target']
    },
  },
  data () {
    return {
      inputText: null,
      addSns: 'X',
      focus: false,
    }
  },
  methods: {
    updatePartsContainer () {
      const values = [{ prop: 'share_text', value: this.inputText }]
      this.$store.commit('updatePartsContainer', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        values,
      })
    },
    // 最初のパーツと同じ属性を、他の全てのパーツに適用させる
    updatePartsAttrs (attrs) {
      // 最初のパーツを飛ばして、インデックス1番からループさせる
      for (let count = 1; count <= this.parts.length - 1; count++) {
        this.$store.commit('updatePart', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          partId: this.parts[count].id,
          attrs: attrs,
        })
      }
    },
    addSnsButton () {
      const newSnsIcon = this.getSnsIconDefaultAttrs(this.addSns)
      if (!newSnsIcon) return
      this.$store.commit('addSnsIcon', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        newSnsIcon: newSnsIcon,
      })
    },
    updateValue (sns) {
      this.addSns = sns
    },
  },
  watch: {
    firstPartAttrHref (href) {
      this.updatePartsAttrs({ 'href': href })
    },
    firstPartAttrTitle (title) {
      this.updatePartsAttrs({ 'title': title })
    },
    firstPartAttrTarget (target) {
      this.updatePartsAttrs({ 'target': target })
    },
    partsContainerId () {
      this.inputText = this.shareText
    },
  },
  mounted () {
    this.inputText = this.shareText
  },
}
</script>

<style lang="scss" scoped>
.share-box {
  padding: 20px 15px;
  border-top: 1px solid #dbdbdb;
  background: #fff;
    .label-title {
      font-size: 14px;
  }
}

.edit-share-text {
  font-size: 14px;
  padding: 5px 0 5px 0;
  .common-input {
    width: 100%;
  }
  label {
    display: block;
    margin:10px 0 0 0;
    &::before {
      padding-right: 8px;
      font-size: 14px;
      font-family: "Font Awesome 5 Free";
    }
  }
}

.flex {
  display: flex;
  align-items: center;
  margin: 20px;
  button {
    margin-left: 10px;
  }
}
</style>
